<template>
    <div>

        <div v-if="message" class="notification is-primary">
          {{ message }}
        </div>


        <form 
            method="POST"
            @submit.prevent="onSubmit" 
            v-if="!submitted" >

            <input type="hidden" name="_token" :value="csrf">

            <div class="field">
              <div class="control">
                <input autofocus :class="{ 'input': true, 'is-danger': $v.permit.$error }" @input="$v.permit.$touch()"  type="text" placeholder="Enter your permit number" id="permit" name="permit" v-model="permit">
                <span v-if="$v.permit.$error && !$v.permit.required" class="help is-danger">Permit number is required</span>
                <span v-if="$v.permit.$error && !$v.permit.numeric" class="help is-danger">Invalid characters entered</span>
              </div>
            </div>

            <div class="field">
              <div class="control">
                <div :class="{ 'select': true, 'is-danger': $v.site.$error }" >
                  <select id="site" @input="$v.site.$touch()" name="site" v-model="site">
                          <option value=0 v-if="lat==0">Select Location</option>
                          <option :value="item.id" v-for="item in items">
                              {{ item.name }}                         
                              <template v-if="item.distance<20">({{ formatNumber(item.distance, 2, '.', ',') }}kms)</template>
                          </option>
                  </select>
                  <div v-if="$v.site.$error && !$v.site.minLength" class="help is-danger" style="margin-bottom: 1em;">Please select site</div>
                </div>
              </div>
            </div>

            <br/>



            <div class="field is-grouped">
              <div class="control">
                <button class="button is-link is-large">CHECKIN</button>
              </div>
            </div>

            <!-- <img src="/images/mobile-food-locations.jpg" style="margin-bottom: 2em;" /> -->

        </form>


    </div>
</template>

<script>
    var Vue = require('vue');

    import { alpha, required, email, numeric, minValue } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';

    export default {

        data () {
           return {
                csrf: '',
                permit: '',
                site: 0,
                items: [],
                message: '',

                currentLocation: {
                   currentLocation: null,
                },

                lat: 0,
                lng: 0,
                submitted: false
           }
        },

        validations: {
          permit: { 
            required, 
            numeric
          },
          site: { 
            required, 
            minValue: minValue(1)
          },

          form: ['permit', 'site']
        },

        computed: {
          formData: function() {
            var fields = {}
              fields.permit = this.permit
              fields.site = this.site
              return JSON.stringify(fields)
          } 
        },
        mounted () {
          //id = navigator.geolocation.watchPosition(success[, error[, options]])    // auto check location when it changes
          //this.getSites(34.84444,138.503690);
          this.getLocation();
          this.getSites(this.lat,this.lng);
        },
        watch: {
            lat: function(val) {
                this.getSites(this.lat, this.lng);
                this.site = this.items[0].id;
            }
        },
        methods: {
            formatNumber(value) {
                let val = (value/1).toFixed(1)
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },            
            getSites: function(lat, lng) {
                //alert(lat + ', '+lng);
                axios.get('/api/mobilefoodvendor/sites/'+lat+'/'+lng)
                    .then(response => {
                        console.log(response.data);
                        this.items = response.data;
                    });
            },
            getLocation: function() {
                //alert('clicked');
                if ('geolocation' in navigator) {
                    var gl = navigator.geolocation
                    gl.getCurrentPosition(function(position) {
                        this.currentLocation = position.coords
                        this.lng = position.coords.longitude
                        this.lat = position.coords.latitude
                        console.log(this.currentLocation)
                    }.bind(this)) // bind to `this` so it's the current component.
        	   } else {
                    console.log('not supported');
               }
            },
            checkIn: function() {
                axios.get('/api/mobilefoodvendor/sites/'+lat+'/'+lng)
                    .then(response => {
                        console.log(response.data);
                        this.items = response.data;
                    });
            },

          validate() {
            this.$v.form.$touch()
            var isValid = !this.$v.form.$invalid
            this.$emit('on-validate', this.$data, isValid)
            return isValid            
          },

          onSubmit() {

            if(this.validate()) {
              axios.post('/mobilefoodvendor/checkin', {
                _token: this.csrf,
                permit: this.permit,
                site: this.site,
                message: ''
              })
              .then((response) => {
                console.log(response.data.message)
                this.message = response.data.message
                this.clear()
                this.submitted = true
              });
            }

          },

          clear() {
            this.permit = ''
            this.site = 0
          },          


        }
    }
</script>





// WEBPACK FOOTER //
// Modules/MobileFoodVendor/Resources/assets/js/components/Checkin.vue